import { headersPublic } from "./headers"
import { Bandeau } from "./model"

async function fetchPublicAPI<T>(url: string): Promise<T> {
    return await fetch(
        `${process.env.NEXT_PUBLIC_SEL_PUBLIC_API_URL}${url}`,
        { headers: headersPublic() }
    ).then(res => res.json())
}

export async function fetchAPIBandeaux(): Promise<Bandeau[]> {
    return await fetchPublicAPI('/config/parametres?categorie=BANDEAUX_INFORMATIONS')
}
